import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Napredek?",
  "description": "",
  "published": "2006-11-15T00:00:00.000Z",
  "redirect_from": ["/blog/napredek/swizec/357"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Pred nekaj dnevi sem razmisljal o napredku Slovenscine in opazil nekaj mocno zanimivega in morda malo strasnega. Izgleda, da obstaja neko nagnjenje k prevzemanju in kraji besed neslovenskega izvora. Tako so v casu nasih prababic vsi uporabljali neke nemske spacenke in jih prav lepo uporabljali v vsakodnevnem jeziku. Zdaj se nam, mlajsmi, to seveda zdi absurdno in uporaba nemscine je nekaj, kar pocno neizobrazeni kmetje. O ne, mi smo boljsi, mi v svoj sleng dodajamo vsevrste angleskih izrazov, ki so tako zelo veliko boljsi od spacenih angleskih kajneda? Opazite, da je ze sama beseda sleng angleskega izvora?`}</p>
    <p>{`Torej kaj za vraga pocnemo s to bogo slovenscino? Ali jo ubijamo sami, ali nam jo velike mocne sile tlacijo v nasa uboga majhna grla?`}</p>
    <p>{`Se ena zelo zabavna stvar pri napredku je statistika letosnjega NaNa. Bisri opazovalec bo namrec tako jopazil, da je bilo v prvih dveh dneh napisanih priblizno 5500 besed, v naslednjih trinajstih pa komaj vec kot 5000. Upam, mocno upam, da v temu ni nekaksnega vzorca, ki me bo preganjal se do konca meseca. Dobro pa je recimo to, da je prislo do prve `}<a parentName="p" {...{
        "href": "http://www.locutio.si/index.php?no=32&clanek=721"
      }}>{`objave`}</a>{` mojega dela v reviji, sicer spletni in samo odlomka, ampak zacetek pa je.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      